






























































import Vue, { PropType } from 'vue';

export type QuestionnaireOpenPoint = { field: string; title: string; group: string };
export type QuestionnaireAttentionPoint = { field: string; note: string; answer: string };

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    // When the assignment was already finished, the confirm dialog frames this as a
    // re-finish (regenerates + replaces the previous PDF) rather than a first finish.
    finished: {
      type: Boolean,
      default: false,
    },

    /** Visible required questions still unanswered; while there are any, finishing is refused. */
    openPoints: {
      type: Array as PropType<QuestionnaireOpenPoint[]>,
      default: () => [],
    },

    attentionPoints: {
      type: Array as PropType<QuestionnaireAttentionPoint[]>,
      default: () => [],
    },
  },

  computed: {
    show: {
      get(): boolean {
        return this.value;
      },

      set(val: boolean) {
        this.$emit('input', val);
      },
    },

    title(): string {
      if (this.openPoints.length) {
        return this.$t('service.questionnaire.notReadyTitle') as string;
      }

      return this.$t(
        this.finished ? 'service.questionnaire.refinishTitle' : 'service.questionnaire.finishTitle',
      ) as string;
    },

    warning(): string {
      return this.$t(
        this.finished ? 'service.questionnaire.refinishWarning' : 'service.questionnaire.finishWarning',
      ) as string;
    },
  },
});
